var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNote = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/note-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "note-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.3796 13.9199L28.0729 19.4933C26.9529 24.3066 24.7396 26.2533 20.5796 25.8533C19.9129 25.7999 19.1929 25.6799 18.4196 25.4933L16.1796 24.9599C10.6196 23.6399 8.89959 20.8933 10.2063 15.3199L11.5129 9.73326C11.7796 8.59993 12.0996 7.61326 12.4996 6.79993C14.0596 3.57326 16.7129 2.7066 21.1663 3.75993L23.3929 4.27993C28.9796 5.5866 30.6863 8.3466 29.3796 13.9199Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5805 25.8534C19.7538 26.4134 18.7138 26.88 17.4471 27.2934L15.3405 27.9867C10.0471 29.6934 7.26045 28.2667 5.54045 22.9734L3.83379 17.7067C2.12712 12.4134 3.54045 9.61338 8.83379 7.90672L10.9405 7.21338C11.4871 7.04005 12.0071 6.89338 12.5005 6.80005C12.1005 7.61338 11.7805 8.60005 11.5138 9.73338L10.2071 15.32C8.90046 20.8934 10.6205 23.64 16.1805 24.96L18.4205 25.4934C19.1938 25.6801 19.9138 25.8 20.5805 25.8534Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.3535 11.3733L23.8202 13.0133",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0469 16.5334L19.9135 17.5201",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/note.55739771.svg";
export { ForwardRef as ReactComponent };